import type { ReactElement } from 'react';

import { TextLink } from '@components/Typography/TextLink/TextLink';

export function Disclaimer(): ReactElement {
  return (
    <div className="text-center text-xs">
      <p>
        All data contained in this calculator has been sourced from the product
        manufacturer’s web site or label.
      </p>
      <p>
        For any queries, please{' '}
        <TextLink href="/contact-us" className="text-inherit underline">
          contact us
        </TextLink>
        .
      </p>
    </div>
  );
}
